import { GridColDef, GridRowModel } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Header, TablePaginated, TableToolBar } from "ui";
import { IconButton, Typography } from "@mui/material";
import { Folder } from "@mui/icons-material";
import { useLazyQuery, useQuery } from "@apollo/client";
import { GET_COMPANY_LOCATIONS } from "../../../features/graphql/query/company";
import { useParams } from "react-router";
import usePersonStore from "../../store/personStore";
interface LocationTableProps {
    handleSelectedLocation: (value: any) => void
}
const mapToTable = (data: any) => {
    return {
        ...data.node,
        postalCode: data.node.postalCode ?? "N/A"
    }
}
const TABLE_COLUMNS: GridColDef[] = [
    {
        field: "name", headerName: "Location Name", width: 150, sortable: true, flex: 1, resizable: false, editable: false, disableColumnMenu: true,
        // renderCell: ({ value }) => (
        //     <Box sx={{ whiteSpace: "break-spaces", lineHeight: 1, }}>
        //         {value}
        //     </Box>
        // )
    },
    {
        field: "postalCode", headerName: "Postal Code", width: 100, flex: 1, resizable: false, editable: false, disableColumnMenu: true,
        // renderCell: ({ value }) => (
        //     <Box sx={{ whiteSpace: "break-spaces", lineHeight: 1, }}>
        //         {value ? value : "N/A"}
        //     </Box>
        // )
    }
]
export function LocationTable({ handleSelectedLocation }: LocationTableProps) {
    const companyId = usePersonStore(state => state.company.id)
    const { loading, data, fetchMore } = useQuery(GET_COMPANY_LOCATIONS, {
        notifyOnNetworkStatusChange: true,
        variables: {
            companyId: companyId!,
            query: "",
            first: 100
        }
    })
    const [pageTableState, setPageTableState] = useState<{
        columns: GridColDef[],
        rows: GridRowModel[],
        filteredRows: GridRowModel[]
        status: "NORMAL" | "FILTERING"
    }>({
        columns: [],
        rows: [],
        filteredRows: [],
        status: "NORMAL"
    })

    useEffect(() => {
        if (data) {
            setPageTableState((prevState) => {
                const columns = [...TABLE_COLUMNS]
                columns.push({
                    field: "customFields", headerName: "Has Custom Fields", sortable: false, flex: 1, resizable: false, editable: false, disableColumnMenu: true,
                    renderHeader: () => (
                        <div style={{ whiteSpace: "break-spaces", fontWeight: 500, lineHeight: 1, textAlign: "center" }}>Has Custom Fields</div>
                    ),
                    renderCell: (params) => {
                        const _customFields = params.row.customFields.length > 0 ? "Yes" : "No"
                        return (<Typography textAlign="center" justifyContent="center">{_customFields}</Typography>)
                    }
                })
                columns.push({
                    field: "details", headerName: "Details", flex: .5, headerAlign: "center", align: "center", sortable: false, resizable: false, editable: false, disableColumnMenu: true,
                    renderCell: (params) => {
                        const onClick = () => { handleSelectedLocation(params.row.id) }
                        return <IconButton onClick={onClick}>
                            <Folder />
                        </IconButton>
                    }
                })
                const rows = data?.locationsByCompanyId?.edges?.map(mapToTable) ?? [];

                return {
                    ...prevState,
                    columns,
                    rows,
                    filteredRows: []
                }
            })
        }
    }, [data, loading])

    return <TablePaginated
        loading={loading}
        
        renderToolbar={({ searchQuery, onSearch, onSearchClear }) => (
            <Header title="Locations" />
            // <TableToolBar
            //     title="Locations"
            //     titleSize="h5"
            //     searchQuery={searchQuery ?? ""}
            //     onSearch={onSearch}
            //     onSearchClear={onSearchClear} />
        )}
        rows={pageTableState.status === "FILTERING"
            ? pageTableState.filteredRows
            : pageTableState.rows}
        columns={pageTableState.columns}
        pageSize={5}
        getRowClassName={(params) => params.row.status === null ? "Active" : "Expired"}
        pageInfo={data?.locationsByCompanyId?.pageInfo}
        autoHeight
        disableBoxShadow
        totalRows={data?.locationsByCompanyId?.totalCount ?? 0}
        onFetchMore={async ({ query }) => {
            await fetchMore({
                variables: {
                    companyId: companyId,
                    query
                },
            })
        }}
    />
}